import React from "react"
import { WarningModal } from "../../practiceProfile/components/WarningModal"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import { populateCmsTemplate } from "../utils"

interface RemoveModalProps {
  text: {
    override?: string
    remove?: string
    itemToRemove?: string
    itemToArchive?: string
    submitButton?: string
    cancelButton?: string
  }
  isOpen: boolean
  onSubmit: () => void
  submitLoading?: boolean
  onCancel: () => void
}

export const RemoveModal: React.FC<RemoveModalProps> = ({
  text,
  isOpen,
  onSubmit,
  submitLoading = false,
  onCancel,
}) => {
  const { cms } = useCMSReady(["common"])

  let warningText: string
  if (text.override) {
    warningText = text.override
  } else if (text.remove) {
    warningText = `${text.remove} ${text.itemToRemove}`
  } else if (text.itemToArchive) {
    warningText = populateCmsTemplate(
      [text.itemToArchive ?? ""],
      "cms.common.confirmArchiveWarning",
      cms.common?.confirmArchiveWarning,
    )
  } else {
    warningText = populateCmsTemplate(
      [text.itemToRemove ?? ""],
      "cms.common.confirmRemoveWarning",
      cms.common?.confirmRemoveWarning,
    )
  }
  if (!text.submitButton) {
    text.submitButton = cms.common?.archive
    text.cancelButton = cms.common?.cancel
  }

  return (
    <WarningModal
      isOpen={isOpen}
      onConfirm={onSubmit}
      confirmLoading={submitLoading}
      onCancel={onCancel}
      text={{
        cancelButton: text.cancelButton,
        confirmButton: text.submitButton,
      }}
      hideIconAndTitle={true}
    >
      {warningText}
    </WarningModal>
  )
}

export default RemoveModal
